import { useEffect, useState } from "react";
import { Phone, Mail, ArrowUp, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/config";

export default function FloatingActions() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const btn =
    "w-12 h-12 rounded-full shadow-lg flex items-center justify-center btn-hover backdrop-blur-md";

  return (
    <div className="fixed right-5 bottom-6 z-40 flex flex-col gap-3">
      <a
        data-testid="fab-whatsapp"
        href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Hi KK Associates, I would like to know more about your services.")}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className={`${btn} bg-emerald-500 text-white hover:bg-emerald-600`}
      >
        <MessageCircle size={20} />
      </a>
      <a
        data-testid="fab-call"
        href={`tel:${CONTACT.phoneRaw}`}
        aria-label="Call"
        className={`${btn} bg-blue-700 text-white hover:bg-blue-800`}
      >
        <Phone size={20} />
      </a>
      <a
        data-testid="fab-email"
        href={`mailto:${CONTACT.email}`}
        aria-label="Email"
        className={`${btn} bg-slate-900 text-white hover:bg-slate-800`}
      >
        <Mail size={20} />
      </a>
      {showTop && (
        <button
          data-testid="fab-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top"
          className={`${btn} bg-white text-slate-900 border border-slate-200 hover:bg-slate-100`}
        >
          <ArrowUp size={20} />
        </button>
      )}
    </div>
  );
}
